// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"um-z","badgeLink":"vm-z","category":"wm-z"};